import { TrackLineItem } from "@/stores/clip/class/Track";
import { TrackConfig } from "@/stores/clip/data/trackConfig";
import { CSSProperties, useMemo } from "react";
import trackState from "@/stores/clip/trackState";

export interface MenuItemProps {
  item: TrackLineItem;
}

const MenuItem = (props: MenuItemProps) => {
  const { item } = props;
  const menus = useMemo(() => {
    return TrackConfig.get(item.type)?.menus ?? [];
  }, [item.type]);

  const top2Menu = useMemo(() => {
    return menus.length > 2 ? [menus[0], "more"] : menus;
  }, [menus]);

  const iconClass = useMemo(() => {
    return TrackConfig.get(item.type)?.icon;
  }, [item.type]);

  const mainTrackStye = useMemo(() => {
    return {
      position:
        item.main &&
        trackState.scrollData.direction &&
        trackState.scrollData.scrollY
          ? "absolute"
          : "relative",
      zIndex: item.main ? 2 : "",
      ...(trackState.scrollData.direction === "down" && item.main
        ? { top: trackState.scrollData.style.top }
        : false),
      ...(trackState.scrollData.direction === "up" && item.main
        ? { bottom: 0 }
        : false),
    } as CSSProperties;
  }, [
    trackState.scrollData?.direction,
    trackState.scrollData?.scrollY,
    trackState.scrollData.style.top,
    item.main,
  ]);

  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: item.type === "video" ? 68 : 34,
        marginBottom: 3,
        ...mainTrackStye,
      }}
    >
      <div className="menu-item">
        <span>
          <i
            className={`iconfont ${iconClass}`}
            style={{ color: "#AE9EFF" }}
          ></i>
        </span>

        {top2Menu.includes("mute") && (
          <span>
            <i className="iconfont icon-laba"></i>
          </span>
        )}

        {top2Menu.includes("visible") && (
          <span>
            <i className="iconfont icon-yanjing"></i>
          </span>
        )}

        {top2Menu.includes("delete") && (
          <span>
            <i className="iconfont icon-icon_huabanfuben"></i>
          </span>
        )}

        {top2Menu.includes("more") && (
          <span>
            <i className="iconfont icon-gengduo"></i>
          </span>
        )}
      </div>
    </div>
  );
};

export default MenuItem;
